import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import DocLayout from '../components/docs/DocLayout'
import Icon from '../components/docs/Icon'
import { searchDocumentation } from '../content/system'
import Cased from '@/components/ui/Cased'
export default function SearchPage() {
  const [params, setParams] = useSearchParams()
  const query = params.get('q') ?? ''
  // Results follow each keystroke; the address and the announced count catch
  // up after a short pause, so a screen reader hears one count, not one a key.
  const [text, setText] = useState(query)
  // A new search from elsewhere, such as the menu's field, replaces the words.
  const [seen, setSeen] = useState(query)
  if (query !== seen) {
    setSeen(query)
    if (query !== text.trim()) setText(query)
  }
  useEffect(() => {
    const value = text.trim()
    if (value === query) return
    const timer = window.setTimeout(() => setParams(value ? { q: value } : {}, { replace: true }), 300)
    return () => window.clearTimeout(timer)
  }, [text, query, setParams])
  const results = searchDocumentation(text)
  return (
    <DocLayout
      eyebrow="Search"
      title="Find your starting point."
      intro="Search foundations, components, patterns, missions and agent guidance."
    >
      <form
        className="doc-search"
        role="search"
        onSubmit={(event) => {
          event.preventDefault()
          const value = String(
            new FormData(event.currentTarget).get('q') ?? '',
          ).trim()
          setParams(value ? { q: value } : {})
        }}
      >
        <label className="mds-visually-hidden" htmlFor="site-search">
          Search MDS
        </label>
        <div className="mds-prompt">
          <Icon name="search" size={19} />
          <input
            id="site-search"
            className="mds-prompt__input"
            type="search"
            name="q"
            value={text}
            onChange={(event) => setText(event.target.value)}
            autoComplete="off"
            placeholder="Try ‘intake’ or ‘tokens’"
          />
          <button className="mds-button mds-button--primary" type="submit">
            Search
          </button>
        </div>
      </form>
      <p className="pat-status" role="status">
        {query
          ? `${results.length} results for “${query}”`
          : 'Explore the documentation'}
      </p>
      <ul className="doc-results">
        {results.map((result) => (
          <li key={result.path}>
            <Link to={result.path} className="doc-result">
              <span className="mds-eyebrow">
                {result.path.startsWith('/patterns/') ? 'PATTERN' : 'GUIDE'}
              </span>
              {' '}
              <span className="doc-result__title">
                {result.title}
                <Icon name="arrow" size={18} />
              </span>
              <span className="mds-muted">{result.description}</span>
            </Link>
          </li>
        ))}
      </ul>
      {results.length === 0 && (
        <div className="pat-empty">
          <h2 className="mds-h3"><Cased>No matching documentation</Cased></h2>
          <p className="mds-muted">
            Try a broader phrase, or browse the pattern library.
          </p>
          <Link className="mds-button mds-button--secondary" to="/patterns">
            Browse patterns
          </Link>
        </div>
      )}
    </DocLayout>
  )
}
